<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">客单价区间分析
          <el-popover
            placement="right"
            width="380"
            trigger="hover"
          >
            <div>1、统计范围为客单价＞0的，客单价为0的数据不算入内</div>
            <div>2、区间为为前闭区间，后闭区间</div>
            <div>（举例：搜索客单价间隔50，区间[0.01 -50 ]，则代表大于等于0.01，小于等于50）</div>
            <div>3、开卡人数：选定时间内首次绑卡的用户</div>
            <i class="el-icon-question" slot="reference" style="color: #aaaaaa;"></i>
          </el-popover>
        </div>
      </div>
      <div class="customer_unitPrice_analysis">
        <!-- 查询条件 -->
        <el-form ref="form" :model="form" label-width="136px">
          <el-form-item label="下单时间：" required>
            <el-radio
              v-for="item in radioList"
              :key="item.value"
              v-model="form.orderTimeType"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-form-item>
          <el-form-item label="客单价分析区间：" required>
            <el-input style="width: 204px;" v-model="form.interval" placeholder="请输入" @input="form.interval = getNumberData($event)"></el-input>
            <span style="margin-left: 30px; color: #333333;">付款时间客户类型：</span>
            <el-select style="width: 204px;" v-model="form.customerType" placeholder="请选择">
              <el-option
                v-for="item in customerList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button class="status_btn status_btn1" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetData">重置</el-button>
            <el-button class="exportData" @click="exportData">导出数据</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
          style="width: 100%; margin-top: 24px;"
          :default-sort = "{prop: 'intervalSort', order: 'ascending'}"
          v-loading="loading"
        >
          <el-table-column prop="intervalSort" label="客单价区间" align="center" sortable>
            <template slot-scope="scope">
              {{ scope.row.interval }}
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="下单人数" align="center" sortable>
          </el-table-column>
          <el-table-column prop="orderRateSort" label="人数占比" align="center" sortable>
            <template slot-scope="scope">
              {{ scope.row.orderRate }}
            </template>
          </el-table-column>
          <el-table-column prop="openCardNum" label="开卡人数" align="center" sortable>
          </el-table-column>
          <el-table-column prop="openCardRateSort" label="开卡占比" align="center" sortable>
            <template slot-scope="scope">
              {{ scope.row.openCardRate }}
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="empty">
              <img src="@/assets/images/default/暂无任何数据.png" />
              <div>暂无任何数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>

    <!-- 生成报表 -->
    <generate
      v-if="control"
      :control="control"
      @transData="(val) => (control = val)"
      @transData1="getphone"
    />
  </div>
</template>

<script>
import generate from "@/components/generate_report.vue";
import { exportDataOne, getTableData } from "@/api/analysis/customer_unitPrice_analysis";

export default {
  components: {
    generate,
  },

  data() {
    return {
      loading: false,
      control: false,
      form: {
        // 表单查询条件
        customerType: "",
        interval: 50,
        orderTimeType: 1,
      },
      radioList: [
        // 下单时间
        {
          label: "近30天",
          value: 1,
        },
        {
          label: "近90天",
          value: 2,
        },
        {
          label: "近180天",
          value: 3,
        },
        {
          label: "近1年",
          value: 4,
        },
        {
          label: "全部",
          value: 0,
        },
      ],
      customerList: [
        // 客户类型
        {
          label: "不限",
          value: "",
        },
        {
          label: "新客",
          value: 1,
        },
        {
          label: "老客",
          value: 2,
        },
      ],
      tableData: [], // 表格数据
      exportParams: {}, // 导出参数
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, "客单价区间分析", "数据分析", "客户分析");
    this.queryData()
  },

  methods: {
    // 限制输入大于等于50
    getNumberData(e) {
      console.log('e------>', e)
      let str = String(e).replace(/[^\d]/g, '')
      const num = Number(str)
      return num
    },

    // 查询
    queryData() {
      if (this.form.interval < 50) {
        this.form.interval = 50
        return this.$message.error("客单价分析区间需输入≥50的正整数")
      }
      this.exportParams = {...this.form}
      this.loading = true
      getTableData(this.form).then((res) => {
        this.loading = false
        if (res.code != 1) {
          return this.$message.error(res.message || res.data.message)
        }
        this.tableData = res.data || []
        this.tableData.map((item) => {
          item.intervalSort = Number(item.interval.indexOf("~") != -1 ? item.interval.split("~")[0] : item.interval.split("以上")[0])
          item.openCardRateSort = Number(item.openCardRate.split("%")[0])
          item.orderRateSort = Number(item.orderRate.split("%")[0])
        })
        console.log('列表------>', this.tableData)
      })
    },

    // 重置
    resetData() {
      this.form = {
        interval: 50,
        customerType: "",
        orderTimeType: 1,
      }
      this.queryData()
    },

    exportData() {
      this.control = true;
    },

    getphone(val) {
      const params = {
        ...this.exportParams,
        exportRemark: val,
      };
      exportDataOne(params).then((res) => {
        if (res.code == 1) {
          this.control = true;
        } else {
          this.$message.error(res.message || res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .customer_unitPrice_analysis {
    padding: 28px;

    .time_box {
      margin-right: 20px;
    }

    .status_btn {
      width: 98px;
      background-color: #fff;
      font-size: 14px;
      margin-left: 20px;
    }

    .status_btn1 {
      color: #fe4d45;
      border-color: #fe4d45;
      margin-left: 0;
    }

    .status_btn1:hover {
      color: #ffffff;
      background-color: #fe4d45;
    }

    .status_btn2 {
      margin-left: 8px;
      color: #333;
      border-color: #d9d9d9;
    }

    .status_btn2:hover {
      color: #fe4d45;
      border-color: #fe4d45;
      background-color: #ffe5e5;
    }

    .exportData {
      float: right;
    }

    .empty {
      padding: 40px 0;
      text-align: center;
      line-height: 30px;
    }

    .toolTipSet {
      width: 600px !important;
    }
  }
}
</style>
